import { useState, useEffect } from "react";
import { Credential } from "@/types/jobPost";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";

export const useCredentials = () => {
  const [credentials, setCredentials] = useState<Credential[] | null>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCredentials = async () => {
      try {
        const response = await axiosInstance.get("jobs/credentials/");

        setCredentials(response.data);
      } catch (err) {
        if (isAxiosError(err)) {
          setError(err.message);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchCredentials();
  }, []);

  return { credentials, loading, error };
};
